import { User } from 'src/components/types';

export type PullRequestListAuthors = {
  authors: User[];
  filteredAuthors: User[];
  isLoading: boolean;
  isError: boolean;
};

export type PullRequestListPreloadedAuthor = {
  author: User | null;
  isLoading: boolean;
  isError: boolean;
};

export type PullRequestList = {
  listItems: any[];
  nextUrl: string | null;
  isLoading: boolean;
  isError: boolean;
  isPreRequestState: boolean;
  reloadUrl: string | null;
  size: number;
  pagelen: number;
};

export type PullRequestListState = {
  pullRequests: PullRequestList;
  pullRequestAuthors: PullRequestListAuthors;
  pullRequestPreloadedAuthor: PullRequestListPreloadedAuthor;
};
